export default "__VITE_ASSET__C67vYeph__"